import script from "./DPassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./DPassword.vue?vue&type=script&lang=ts&setup=true"

import "./DPassword.vue?vue&type=style&index=0&id=7e2db3bf&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e2db3bf"]])

export default __exports__